import React, { Component } from "react";
import styled from "styled-components";
import { format } from 'date-fns';
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import { CardPageLayout } from "component-lib/CardPageLayout";
import { quotesGetQuotes, loanDetailGetLoan } from './quoteHistory.store';
import { QuoteHistoryBodyList } from './quoteHistoryBodyList';
import { QuoteHistoryHeader } from './quoteHistoryHeader';
import { mapCompanySelector } from "store/state/auth";
import loanStatuses from "constants/loanStatuses";
import { GenericHeroCard } from "component-lib/";
import { findDistinctLendersByQuotes } from "./quoteHistory.filters";

const StyledHeroCardPlaceholder = styled.div`	
  width: 360px;	
  height: 563px;	
  background-color: lightblue;	
  border-radius: 8px;	
`;

const StyledModuleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTableContainer = styled.div`
  margin-top: 26px
`;
const MAX_LENDERS_TO_SHOW = 3;
class QuoteHistory extends Component {
  state = {
    distinctLenders: [],
  }
  componentDidMount() {
    const { loanId } = this.props.match.params;
    this.quotesGetQuotes(loanStatuses.WINNING_QUOTE, "winning_quote_loan_table");
    this.quotesGetQuotes(loanStatuses.PASSED_QUOTE, "lender_passed_loan_table");
    this.quotesGetQuotes(loanStatuses.REJECTED_QUOTE, "rejected_loan_table");
    this.props.loanDetailGetLoan({ loanId });
  }


  quotesGetQuotes = (loanStatusId, subKey) => {
    const { loanId } = this.props.match.params;
    let payload = { loanId, page: 0, pageSize: 10, loanStatusId, subKey, isRaw: false }
    this.props.quotesGetQuotes(payload);
  }
  toLoanDetails = (loanId) => {
    const { history } = this.props;
    history.push(`/loans/${loanId}`)
  }
  renderBodyList = (sortedLoans) => {
    return (<QuoteHistoryBodyList loans={sortedLoans} toLoanDetails={this.toLoanDetails} />);
  }

  renderBody = () => {
    const { quotes, authentication } = this.props;
    const { distinctLenders } = this.state;

    const distinctLenders_winning_quote_loan_table = quotes.winning_quote_loan_table && findDistinctLendersByQuotes(quotes.winning_quote_loan_table.data.loans, MAX_LENDERS_TO_SHOW);
    const distinctLenders_lender_passed_loan_table = quotes.lender_passed_loan_table && findDistinctLendersByQuotes(quotes.lender_passed_loan_table.data.loans, MAX_LENDERS_TO_SHOW);
    const distinctLenders_rejected_loan_table = quotes.rejected_loan_table && findDistinctLendersByQuotes(quotes.rejected_loan_table.data.loans, MAX_LENDERS_TO_SHOW);

    return (<StyledModuleContainer>
      {quotes.winning_quote_loan_table && quotes.winning_quote_loan_table.data.loans && quotes.winning_quote_loan_table.data.loans.length > 0 &&
        <StyledTableContainer>
          <QuoteHistoryHeader title={"Winning"} loans={quotes.winning_quote_loan_table.data.loans} distinctLenders={distinctLenders_winning_quote_loan_table} authentication={authentication} />
          {quotes.winning_quote_loan_table && this.renderBodyList(quotes.winning_quote_loan_table.data.loans)}
        </StyledTableContainer>}
      {quotes.lender_passed_loan_table && quotes.lender_passed_loan_table.data.loans && quotes.lender_passed_loan_table.data.loans.length > 0 &&
        <StyledTableContainer>
          <QuoteHistoryHeader title={"Passed"} loans={quotes.lender_passed_loan_table.data.loans} distinctLenders={distinctLenders_lender_passed_loan_table} authentication={authentication} />
          {quotes.lender_passed_loan_table && this.renderBodyList(quotes.lender_passed_loan_table.data.loans)}
        </StyledTableContainer>}
      {quotes.rejected_loan_table && quotes.rejected_loan_table.data.loans && quotes.rejected_loan_table.data.loans.length > 0 &&
        <StyledTableContainer>
          <QuoteHistoryHeader title={"Rejected"} loans={quotes.rejected_loan_table.data.loans} distinctLenders={distinctLenders_rejected_loan_table} authentication={authentication} />
          {quotes.rejected_loan_table && this.renderBodyList(quotes.rejected_loan_table.data.loans)}
        </StyledTableContainer>}
    </StyledModuleContainer>);
  }

  renderHeroCard = () => {
    const { loan } = this.props;
    if (!loan || !loan.details) return null;
    const year = format(new Date(loan.details.closingDate), 'yyyy');
    const title = `${loan.details["lenderCompany.name"]} ${year}`;
    return (
      <div>
        <GenericHeroCard {...{ ...this.props, deal: loan.details.deal, title: title, backLabel: "Loan Summary" }} />
      </div>
    );
  }

  render() {

    return (
      <>
        <CardPageLayout {...this.props}
          isReversed
          bannerImageUrl={this.props.company && this.props.company.bannerImage}
          cardComponent={this.renderHeroCard()}
          bodyComponent={this.renderBody()}
        />
      </>
    );
  }
}

const mapStateToProps = ({ quoteHistory, authentication }) => ({
  ...quoteHistory
  , company: mapCompanySelector(authentication)
  , authentication
});

export default compose(
  withRouter
  , connect(mapStateToProps, {
    quotesGetQuotes
    , loanDetailGetLoan
  })
)(QuoteHistory);
